import { useEffect } from "react";
import { useBreadcrumbs } from "../../contexts/breadcrumb";

import CalendarToday from "@material-ui/icons/CalendarToday";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { useReschedulingListStyles } from "./styles";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { useListStyles } from "./styles-list";
import SearchField from "../AttendanceLocal/components/search-field";
import Button from "@material-ui/core/Button";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import { useReschedulingList } from "../../services/api-tansquery/rescheduling-list";
import { TableBody } from "@material-ui/core";
import EmptyState from "../../Components/EmptyState";
import dateFormat, { dateformat } from "../../utils/dateFormat";
import { useReschedulingDownloadPDF } from "../../services/api-tansquery/rescheduling-download";

export default function Rescheduling() {
  const { setBreadcrumbs } = useBreadcrumbs();
  const { classes: defaultClasses } = useListStyles();
  const { classes } = useReschedulingListStyles();
  const { data: reschedulingList } = useReschedulingList();
  const { refetch, isFetching } = useReschedulingDownloadPDF();

  useEffect(() => {
    setBreadcrumbs((prev) => {
      const homeBreadcrumb = prev.find((_, index) => index === 0);
      return [
        homeBreadcrumb,
        {
          label: "Reagendamentos",
          path: "/reagendamentos",
          icon: CalendarToday,
        },
      ];
    });
  }, [setBreadcrumbs]);

  const handleDownload = async () => {
    const { data: blob } = await refetch();
    if (!blob) return;

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "reagendamentos-arquivo.pdf";
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  const isEmptyList = (reschedulingList?.results ?? []).length === 0;

  return (
    <Box>
      <Box className={classes.header}>
        <Typography className={classes.title}>
          Relatórios de Reagendamentos{" "}
        </Typography>
        <Button
          disabled={isFetching}
          onClick={handleDownload}
          startIcon={<PictureAsPdfIcon />}
          className={defaultClasses.addButton}
        >
          {isFetching ? "Baixando..." : "Imprimir"}
        </Button>
      </Box>
      <Paper elevation={3}>
        <SearchField placeholder="Buscar por unidade ou motivo..." />
        <TableContainer className={defaultClasses.tableContainer}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell className={defaultClasses.tableTH}>
                  Unidade
                </TableCell>
                <TableCell className={defaultClasses.tableTH}>Motivo</TableCell>
                <TableCell className={defaultClasses.tableTH}>
                  Concluído
                </TableCell>
                <TableCell className={defaultClasses.tableTH}>
                  Data referente
                </TableCell>
                <TableCell className={defaultClasses.tableTH}>
                  Adicionado em
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {reschedulingList?.results.map((item) => (
                <TableRow
                  hover
                  key={item.identificador}
                  role="checkbox"
                  tabIndex={-1}
                >
                  <TableCell className={defaultClasses.tableCell}>
                    {item.unidade.nome}
                  </TableCell>
                  <TableCell className={defaultClasses.tableCell}>
                    {item.motivo}
                  </TableCell>
                  <TableCell className={defaultClasses.tableCell}>
                    <Box
                      className={`${defaultClasses.badge} ${
                        item.concluido
                          ? defaultClasses.active
                          : defaultClasses.inactive
                      }`}
                    >
                      {item.concluido ? "Sim" : "Não"}
                    </Box>
                  </TableCell>
                  <TableCell className={defaultClasses.tableCell}>
                    {dateFormat(item.data_referente, false)}
                  </TableCell>
                  <TableCell className={defaultClasses.tableCell}>
                    {dateformat(item.created_at, true)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {isEmptyList && (
            <EmptyState message="Nenhum reagendamento encontrado." />
          )}
        </TableContainer>
      </Paper>
    </Box>
  );
}
